export default __webpack_public_path__ + "static/notebook-cover-d86d9d423195f9a69c52f05f6d472596.png";